var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-item clickable",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }